<div class="container">
  <mat-card>
    <mat-card-title class="btn btn-rose">Edit Brand</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
    <mat-card-content>
      <form [formGroup]="editBrandForm" (ngSubmit)="saveBrand()" novalidate>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-6">
            <mat-form-field color="accent">
              <mat-label>Brand Name</mat-label>
              <input matInput type="text" placeholder="Brand Name" name="brandName" required 
              formControlName ="brandName"  appInputValidator  [sanitizeScriptTags]="true" [hasAtLeastOneAlphabet]="true">
            <mat-error
            *ngIf="editBrandForm.get('brandName').hasError('required')"
          >
            Brand Name is required.
          </mat-error>
          <mat-error
            *ngIf="editBrandForm.get('brandName').hasError('maxlength')"
          >
            Brand Name cannot be more than 50 characters.
          </mat-error>
           <mat-error *ngIf="editBrandForm.get('brandName').hasError('noAlphabet')">
              Must contain at least one alphabet.
            </mat-error>
        </mat-form-field>
          </div>
          <div class="col-12 col-sm-12 col-md-6">
            <mat-form-field color="accent">
              <mat-label>Description</mat-label>
              <input matInput type="text" placeholder="Description" id="description"
               name="description" formControlName ="description" required
               appInputValidator  [sanitizeScriptTags]="true" [hasAtLeastOneAlphabet]="true">
              <mat-error
              *ngIf="editBrandForm.get('description').hasError('required')"
            >
              Description is required.
            </mat-error>
            <mat-error
              *ngIf="editBrandForm.get('description').hasError('maxlength')"
            >
              Description cannot be more than 100 characters.
            </mat-error>
              <mat-error *ngIf="editBrandForm.get('description').hasError('noAlphabet')">
              Must contain at least one alphabet.
            </mat-error>
            </mat-form-field>
          </div>
        </div>
      </form>
    </mat-card-content>
    <mat-card-footer>
      <div class="row action-btn justify-content-center">
          <div class="row action-btn">
              <button md-raised-button type="button" class="btn btn-rose" (click)="close()">Close</button>
              <button md-raised-button type="button" class="btn btn-rose" (click)="saveBrand()"  [disabled]="!editBrandForm.valid">Update</button>
          </div>
      </div>
    </mat-card-footer>
  </mat-card>
</div>